function view (path) {
  return () => import(/* webpackChunkName: 'prd-v1' */ '@/views/user/prd/' + path).then(m => m.default || m) // eslint-disable-line prefer-template
}

// function viewPurchaseOrders (path) {
//   return view('purchase-orders/' + path)
// }

function viewInterWarehouses (path) {
  return view('inter-warehouses/' + path)
}

function viewAuthorityToWithdraws (path) {
  return view('atws/' + path)
}

const RProduction = [
  {
    path: '/production/dashboard',
    component: view('Dashboard'),
    name: 'prd.dashboard',
    authorizedRole: 'user'
  }
]

// const RPRDPurchaseOrders = [
//   {
//     path: '/production/purchase-orders/requests/:requester?/:status?',
//     component: viewPurchaseOrders('requests/Base'),
//     name: 'prd.purchase-orders.requests',
//     authorizedRole: 'user',
//     meta: {
//       breadcrumb: [
//         {
//           text: 'Warehouse'
//         },
//         {
//           text: 'Purchase Orders'
//         },
//         {
//           text: 'Requests',
//           active: true
//         }
//       ]
//     }
//   },
//   {
//     path: '/production/purchase-orders/approvals/:approver?/:status?',
//     component: viewPurchaseOrders('approvals/Base'),
//     name: 'prd.purchase-orders.approvals',
//     authorizedRole: 'user',
//     meta: {
//       breadcrumb: [
//         {
//           text: 'Warehouse'
//         },
//         {
//           text: 'Purchase Orders'
//         },
//         {
//           text: 'Approvals',
//           active: true
//         }
//       ]
//     }
//   },
//   {
//     path: '/production/purchase-orders/posting/:poster?/:status?',
//     component: viewPurchaseOrders('posting/Base'),
//     name: 'prd.purchase-orders.posting',
//     authorizedRole: 'user',
//     meta: {
//       breadcrumb: [
//         {
//           text: 'Warehouse'
//         },
//         {
//           text: 'Purchase Orders'
//         },
//         {
//           text: 'Posting',
//           active: true
//         }
//       ]
//     }
//   },
//   {
//     path: '/production/purchase-orders/receiving/:receiver?/:status?',
//     component: viewPurchaseOrders('receiving/Base'),
//     name: 'prd.purchase-orders.receiving',
//     authorizedRole: 'user',
//     meta: {
//       breadcrumb: [
//         {
//           text: 'Warehouse'
//         },
//         {
//           text: 'Purchase Orders'
//         },
//         {
//           text: 'Receiving',
//           active: true
//         }
//       ]
//     }
//   }
// ]

const RPRDAuthorityToWithdraws = [
  {
    path: '/production/atws/receiving/:receiver?/:status?',
    component: viewAuthorityToWithdraws('receiving/Base'),
    name: 'prd.atws.receiving',
    authorizedRole: 'user',
    meta: {
      breadcrumb: [
        {
          text: 'Warehouse'
        },
        {
          text: 'Authority To Withdraws'
        },
        {
          text: 'Receiving',
          active: true
        }
      ]
    }
  }
]

const RPRDInterWarehouses = [
  {
    path: '/production/inter-warehouses/transfers/:transfer?/:status?',
    component: viewInterWarehouses('transfers/Base'),
    name: 'prd.inter-warehouses.transfers',
    authorizedRole: 'user',
    meta: {
      breadcrumb: [
        {
          text: 'Warehouse'
        },
        {
          text: 'Inter Warehouses'
        },
        {
          text: 'Transfers',
          active: true
        }
      ]
    }
  },
  {
    path: '/production/inter-warehouses/posting/:poster?/:status?',
    component: viewInterWarehouses('posting/Base'),
    name: 'prd.inter-warehouses.posting',
    authorizedRole: 'user',
    meta: {
      breadcrumb: [
        {
          text: 'Warehouse'
        },
        {
          text: 'Inter Warehouses'
        },
        {
          text: 'Posting',
          active: true
        }
      ]
    }
  },
  {
    path: '/production/inter-warehouses/receiving/:receiver?/:status?',
    component: viewInterWarehouses('receiving/Base'),
    name: 'prd.inter-warehouses.receiving',
    authorizedRole: 'user',
    meta: {
      breadcrumb: [
        {
          text: 'Warehouse'
        },
        {
          text: 'Inter Warehouses'
        },
        {
          text: 'Receiving',
          active: true
        }
      ]
    }
  }
]

export default RProduction.concat(
  // RPRDPurchaseOrders,
  RPRDAuthorityToWithdraws,
  RPRDInterWarehouses
)
